export default __webpack_public_path__ + "locales/pt/Article.json?hash=649b280acc3919f0b7d16eb73ac2c382";